import { FC } from "react";
import './EpiDonut.scss';

interface Segment {
	label: string;
	value: number;
	color: string;
}

interface Props {
	segments: Segment[];
	total: number;
	totalLabel: string;
	centerValue?: string;
	legendValueFormatter?: (segment: Segment, total: number) => string;
}

const RADIUS = 54;
const STROKE = 22;
const GAP = 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const EpiDonut: FC<Props> = ({ segments, total, totalLabel, centerValue, legendValueFormatter }) => {
	let consumed = 0;
	return (
		<div className="epi-donut">
			<svg viewBox="0 0 140 140" role="img" aria-label={`${totalLabel}: ${centerValue ?? total}`}>
				<circle
					className="trilho"
					cx="70"
					cy="70"
					r={RADIUS}
					fill="none"
					strokeWidth={STROKE}
				/>
				{segments.filter(segment => segment.value > 0).map(segment => {
					const length = total ? segment.value / total * CIRCUMFERENCE : 0;
					const dash = Math.max(length - GAP, 0.5);
					const offset = consumed;
					consumed += length;
					return (
						<circle
							key={segment.label}
							cx="70"
							cy="70"
							r={RADIUS}
							fill="none"
							stroke={segment.color}
							strokeWidth={STROKE}
							strokeDasharray={`${dash} ${CIRCUMFERENCE - dash}`}
							strokeDashoffset={-offset}
							transform="rotate(-90 70 70)"
						/>
					);
				})}
				<text className="total" x="70" y="66" textAnchor="middle">{centerValue ?? total}</text>
				<text className="rotulo-total" x="70" y="84" textAnchor="middle">{totalLabel}</text>
			</svg>
			<div className="legenda">
				{segments.map(segment => (
					<div className="item" key={segment.label}>
						<span className="ponto" style={{ backgroundColor: segment.color }} />
						<span className="rotulo">{segment.label}</span>
						<span className="valor">
							{legendValueFormatter
								? legendValueFormatter(segment, total)
								: `${segment.value} (${total ? (segment.value * 100 / total).toFixed(0) : 0}%)`}
						</span>
					</div>
				))}
			</div>
		</div>
	);
};

export default EpiDonut;
